import React from 'react'
import { ScrollView } from 'react-native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { MobileAppFeature } from '@src/types'
import { User } from '@src/utils'
import AdminSection from './AdminSection'
import SystemSection from './SystemSection'
import SensorSection from './SensorSection'
import IntegrationsSection from './IntegrationsSection'
import ExportDataSection from './ExportDataSection'
import ClearCachesSection from './ClearCachesSection'
import CancellationPolicySection from './CancellationPolicySection'
import PrivacyPolicySection from './PrivacyPolicySection'
import TermsOfUseSection from './TermsOfUseSection'
import OpenSourceLicensesSection from './OpenSourceLicensesSection'
import VersionSection from './VersionSection'
import NotificationsSection from './NotificationsSection'

const SettingsComponent = () => {
  const styles = useStyleSheet(themedStyles)
  const hasBiosensorAccess = User.hasFeature(MobileAppFeature.BiosensorAccess)

  return (
    <ScrollView style={styles.container}>
      <AdminSection />
      <NotificationsSection />
      <SystemSection />
      {hasBiosensorAccess && <SensorSection />}
      <IntegrationsSection />
      <ExportDataSection style={styles.infoSection} />
      <ClearCachesSection />
      <CancellationPolicySection style={[styles.policySection, styles.infoSection]} />
      <PrivacyPolicySection style={styles.policySection} />
      <TermsOfUseSection style={styles.policySection} />
      <OpenSourceLicensesSection style={styles.policySection} />
      <VersionSection style={[styles.policySection, styles.infoSection]} />
    </ScrollView>
  )
}

export default SettingsComponent

const themedStyles = StyleService.create({
  container: {
    flex: 1,
    backgroundColor: 'theme.background',
  },
  infoSection: {
    marginTop: 16,
  },
  policySection: {
    height: 48,
    paddingVertical: 0,
    paddingHorizontal: 24,
  },
})
